import { Fragment } from "react";
import { useAuth } from "./AuthProvider";

interface HasRoleProps {
  roles: string[];
  children: React.ReactNode;
}

export const HasRole = ({ roles, children }: HasRoleProps) => {
  const { user } = useAuth();
  const role = user?.role;
  if (role && (roles.includes(role) || role === "superadmin")) {
    return <Fragment>{children}</Fragment>;
  }

  return null;
};
